module.exports = __webpack_public_path__ + "img/2.0eaa9a40.png";